if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      this.isPaused = false;
      this.autoplayTimer = null;

      this.bindEvents();
      this.init();
    }

    disconnectedCallback() {
      this.clearAutoplay();
      if (this.moveLinksHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLinksHandler);
      }
      if (this.moveLocalizationHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.goPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.goNext);
    }

    bindEvents() {
      if (this.links?.length) {
        this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this);
        window.addEventListener('on:breakpoint-change', this.moveLinksHandler);
      }
      if (this.localization) {
        this.moveLocalizationHandler = this.moveLocalizationHandler || this.moveLocalization.bind(this);
        window.addEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }
      if (this.slider) {
        this.slider.addEventListener('mouseenter', () => { this.isPaused = true; });
        this.slider.addEventListener('mouseleave', () => { this.isPaused = false; });
        this.slider.addEventListener('scroll', () => this.updatePagination());
      }
      this.prevBtn = this.querySelector('.announcement__btn--prev');
      this.nextBtn = this.querySelector('.announcement__btn--next');
      if (this.prevBtn) {
        this.goPrev = this.goPrev.bind(this);
        this.prevBtn.addEventListener('click', this.goPrev);
      }
      if (this.nextBtn) {
        this.goNext = this.goNext.bind(this);
        this.nextBtn.addEventListener('click', this.goNext);
      }
    }

    init() {
      if (this.slider) {
        const slides = this.slider.querySelectorAll('.announcement__text');
        if (slides.length) {
          slides[0].classList.add('is-visible');
          this.initPagination(slides.length);
          const delay = parseInt(this.dataset.slideDelay, 10) || 0;
          if (delay > 0) this.startAutoplay(delay);
        }
      }
      if (this.links?.length) this.moveLinks();
      if (this.localization) this.moveLocalization();
    }

    clearAutoplay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    startAutoplay(delay) {
      const nextSlide = () => {
        if (this.isPaused || !this.slider) return;
        const inView = theme?.elementUtil?.isInViewport ? theme.elementUtil.isInViewport(this) : true;
        if (!inView) {
          this.autoplayTimer = setTimeout(nextSlide, delay);
          return;
        }
        const slides = this.slider.querySelectorAll('.announcement__text');
        if (slides.length < 2) return;
        const curr = this.slider.querySelector('.announcement__text.is-visible');
        const idx = curr ? Array.from(slides).indexOf(curr) : 0;
        const nextIdx = idx + 1 < slides.length ? idx + 1 : 0;
        this.goToSlide(nextIdx);
        this.autoplayTimer = setTimeout(nextSlide, delay);
      };
      this.autoplayTimer = setTimeout(nextSlide, delay);
    }

    goToSlide(index) {
      const slides = this.slider.querySelectorAll('.announcement__text');
      if (!slides[index]) return;
      slides.forEach((s, i) => s.classList.toggle('is-visible', i === index));
      const slide = slides[index];
      this.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      this.updatePagination();
    }

    goPrev() {
      const slides = this.slider?.querySelectorAll('.announcement__text');
      if (!slides || slides.length < 2) return;
      const curr = this.slider.querySelector('.announcement__text.is-visible');
      const idx = curr ? Array.from(slides).indexOf(curr) : 0;
      const prevIdx = idx > 0 ? idx - 1 : slides.length - 1;
      this.goToSlide(prevIdx);
    }

    goNext() {
      const slides = this.slider?.querySelectorAll('.announcement__text');
      if (!slides || slides.length < 2) return;
      const curr = this.slider.querySelector('.announcement__text.is-visible');
      const idx = curr ? Array.from(slides).indexOf(curr) : 0;
      const nextIdx = idx + 1 < slides.length ? idx + 1 : 0;
      this.goToSlide(nextIdx);
    }

    initPagination(count) {
      const pagination = this.querySelector('.announcement__pagination');
      if (!pagination || count < 2) return;
      pagination.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'announcement__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Slide ${i + 1}`);
        dot.addEventListener('click', () => this.goToSlide(i));
        pagination.appendChild(dot);
      }
    }

    updatePagination() {
      const slides = this.slider?.querySelectorAll('.announcement__text');
      const dots = this.querySelectorAll('.announcement__dot');
      if (!slides?.length || !dots.length) return;
      const scrollLeft = this.slider.scrollLeft;
      const containerWidth = this.slider.clientWidth;
      let activeIdx = 0;
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].offsetLeft >= scrollLeft - containerWidth / 2) {
          activeIdx = i;
          break;
        }
        activeIdx = i;
      }
      dots.forEach((d, i) => d.classList.toggle('is-active', i === activeIdx));
      slides.forEach((s, i) => s.classList.toggle('is-visible', i === activeIdx));
    }

    moveLinks() {
      const menuAnnouncementLinks = document.querySelector('.mob__announcement-links');
      if (!theme?.mediaMatches?.md && !menuAnnouncementLinks && this.menu) {
        const mobNav = document.createElement('nav');
        mobNav.classList.add('mob__announcement-links');
        const mobNavUl = document.createElement('ul');
        mobNavUl.classList.add('secondary-nav');
        this.links.forEach((link) => {
          mobNavUl.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a>`;
        });
        mobNav.appendChild(mobNavUl);
        this.menu.appendChild(mobNav);
      } else if (theme?.mediaMatches?.md && menuAnnouncementLinks) {
        menuAnnouncementLinks.remove();
      }
    }

    moveLocalization() {
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      const menuLocalization = document.querySelector('.mob__localization');
      if (!theme?.mediaMatches?.md && !menuLocalization && this.localization) {
        const mobLocalizationElem = document.createElement('div');
        mobLocalizationElem.classList.add('mob__localization');
        mobLocalizationElem.appendChild(this.localization.firstElementChild);
        this.menu?.appendChild(mobLocalizationElem);
      } else if (theme?.mediaMatches?.md && menuLocalization && this.localization) {
        this.localization.appendChild(menuLocalization.firstElementChild);
        menuLocalization.remove();
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
